import React, { useEffect, useRef } from "react";
import { Outlet } from "react-router-dom";
import NavBar from "../components/NavBar";
import { useSelector } from "react-redux";
import { useOverFlow } from "../context/OverFlowContext";
const MainLayout = () => {
  const { overflow } = useOverFlow();
  const ticketListConfig = useSelector((state) => state.root.ticketListConfig);
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    const handleWheel = (e) => {
      if (!overflow) {
        e.preventDefault();
      }
    };

    const handleTouchMove = (e) => {
      if (!overflow) {
        e.preventDefault();
      }
    };

    if (!overflow) {
      scrollContainer.addEventListener("wheel", handleWheel, {
        passive: false,
      });
      scrollContainer.addEventListener("touchmove", handleTouchMove, {
        passive: false,
      });
    }

    return () => {
      scrollContainer.removeEventListener("wheel", handleWheel);
      scrollContainer.removeEventListener("touchmove", handleTouchMove);
    };
  }, [overflow]);

  if (!ticketListConfig)
    return <div className="h-dvh w-full animate-pulse bg-customGray"></div>;
  return (
    <div className="h-dvh flex flex-col bg-customGrayExtraLight">
      <NavBar />
      <div ref={scrollContainerRef} className="overflow-y-auto flex-1">
        <div className="container mx-auto py-10">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
